/**
 * API配置文件
 * 
 * 注意：使用占位符 https://kidopally.cn，在容器启动时通过 entrypoint.sh 动态替换
 * 这样可以实现运行时配置，无需为不同环境构建不同的镜像
 */

// 获取API基础URL
// 开发环境：使用环境变量或代理
// 生产环境：使用占位符，运行时替换
function getApiBaseUrl(): string {
  // 开发环境：使用环境变量或代理
  if (process.env.NODE_ENV === 'development') {
    const envApiUrl = process.env.REACT_APP_API_BASE_URL;
    if (envApiUrl) {
      return envApiUrl;
    }
    // 开发环境使用空字符串（通过代理转发）
    return '';
  }
  
  // 生产环境：使用占位符，运行时会被 entrypoint.sh 替换为实际值
  // 占位符格式：https://kidopally.cn
  return 'https://kidopally.cn';
}

export const API_BASE_URL = getApiBaseUrl();

// Portal相关API路径
export const PORTAL_API = {
  CONFIG: '/app/api/portal/config',
} as const;

// 完整的API端点
export const API_ENDPOINTS = {
  PORTAL: {
    CONFIG: API_BASE_URL ? `${API_BASE_URL}${PORTAL_API.CONFIG}` : PORTAL_API.CONFIG,
  },
} as const;

